/* 肥後屋 — ハンバーガーメニューを「メニュー以外の場所」でも閉じる（HIGOYA-105）
 *
 * 指示: 右上の「×」を押さないと閉じないので、背景をクリック・タップしても
 * 閉じるようにする。
 *
 * 閉じ方は summary.click() に寄せている。Rise の MenuDrawer は
 * onSummaryClick → closeMenuDrawer で body のスクロールロック解除・
 * フォーカストラップ解除・閉じアニメーションまで面倒を見るので、ここで
 * details から open を外すなど独自に閉じるとロックが残る（別の閉じるボタンを
 * 新設しない設計にしているのと同じ理由。snippets/header-drawer.liquid 参照）。
 *
 * document への委譲にしているのは、テーマエディタのセクション再描画
 * （shopify:section:load）でヘッダーのDOMが丸ごと入れ替わっても、
 * バインドし直さずに効き続けるようにするため。
 */
(function () {
  if (window.lpNavCloseBound) return;
  window.lpNavCloseBound = true;

  document.addEventListener('click', function (event) {
    var overlay = event.target.closest && event.target.closest('.lp-nav-overlay');
    if (!overlay) return;

    var details = overlay.closest('details[open]');
    var summary = details && details.querySelector(':scope > summary');
    if (summary) summary.click();
  });
})();
